// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607301804/js/" + chunkId + "." + {"44":"192dddcb","225":"1335a3a8","481":"213fa32b","486":"c4011b94","770":"d24c8271"}[chunkId] + ".0.4820303934916178.chunk.js";
};